import { _ as _defineProperty, t as toCssDimension, g as getValueByPath, a as _toConsumableArray, j as indexOf, k as multiColumnSort } from './helpers-d639255d.js';
import { n as normalizeComponent, B as BaseComponentMixin, c as config, V as VueInstance, b as registerComponent, u as use } from './plugins-4295ce0e.js';
import { _ as __vue_component__$6 } from './Icon-9c764942.js';
import './FormElementMixin-f9847bcc.js';
import { _ as __vue_component__$9 } from './Input-69be569b.js';
import { _ as __vue_component__$4 } from './Button-de757e21.js';
import './CheckRadioMixin-51125787.js';
import { _ as __vue_component__$8 } from './Checkbox-f3239c52.js';
import { _ as __vue_component__$7 } from './Field-1c155254.js';
import './ssr-44a76b0e.js';
import { _ as __vue_component__$b } from './Loading-cb689aba.js';
import { _ as __vue_component__$a } from './Pagination-70e0ba98.js';
import { _ as __vue_component__$5 } from './Select-5a25a557.js';
import { S as SlotComponent } from './SlotComponent-11e2db3a.js';

var _components;
var script = {
  name: 'OTableMobileSort',
  components: (_components = {}, _defineProperty(_components, __vue_component__$4.name, __vue_component__$4), _defineProperty(_components, __vue_component__$5.name, __vue_component__$5), _defineProperty(_components, __vue_component__$6.name, __vue_component__$6), _defineProperty(_components, __vue_component__$7.name, __vue_component__$7), _components),
  inject: {
    $table: {
      name: '$table',
      default: false
    }
  },
  props: {
    currentSortColumn: Object,
    sortMultipleData: Array,
    columns: Array,
    placeholder: String,
    iconPack: String,
    sortIcon: {
      type: String,
      default: 'arrow-up'
    },
    sortIconSize: {
      type: String,
      default: 'small'
    },
    sortMultiple: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      sortMultipleSelect: '',
      mobileSort: this.currentSortColumn,
      defaultEvent: {
        shiftKey: true,
        altKey: true,
        ctrlKey: true
      },
      ignoreSort: false
    };
  },
  computed: {
    showPlaceholder: function showPlaceholder() {
      var _this = this;

      return !this.columns || !this.columns.some(function (column) {
        return column === _this.mobileSort;
      });
    },
    sortableColumns: function sortableColumns() {
      if (!this.columns) return [];
      return this.columns.filter(function (c) {
        return c.sortable;
      });
    }
  },
  watch: {
    sortMultipleSelect: function sortMultipleSelect(column) {
      if (this.ignoreSort) {
        this.ignoreSort = false;
      } else {
        this.$emit('sort', column, this.defaultEvent);
      }
    },
    mobileSort: function mobileSort(column) {
      if (this.currentSortColumn === column) return;
      this.$emit('sort', column, this.defaultEvent);
    },
    currentSortColumn: function currentSortColumn(column) {
      this.mobileSort = column;
    }
  },
  methods: {
    removePriority: function removePriority() {
      var _this2 = this;

      this.$emit('removePriority', this.sortMultipleSelect); // ignore the watcher to sort when we just change whats displayed in the select
      // otherwise the direction will be flipped
      // The sort event is already triggered by the emit

      this.ignoreSort = true; // Select one of the other options when we reset one

      var remainingFields = this.sortMultipleData.filter(function (data) {
        return data.field !== _this2.sortMultipleSelect.field;
      }).map(function (data) {
        return data.field;
      });
      this.sortMultipleSelect = this.columns.filter(function (column) {
        return remainingFields.includes(column.field);
      })[0];
    },
    getSortingObjectOfColumn: function getSortingObjectOfColumn(column) {
      return this.sortMultipleData.filter(function (i) {
        return i.field === column.field;
      })[0];
    },
    columnIsDesc: function columnIsDesc(column) {
      var sortingObject = this.getSortingObjectOfColumn(column);

      if (sortingObject) {
        return !!(sortingObject.order && sortingObject.order === 'desc');
      }

      return true;
    },
    getLabel: function getLabel(column) {
      var sortingObject = this.getSortingObjectOfColumn(column);

      if (sortingObject) {
        return column.label + '(' + (this.sortMultipleData.indexOf(sortingObject) + 1) + ')';
      }

      return column.label;
    },
    sort: function sort() {
      this.$emit('sort', this.sortMultiple ? this.sortMultipleSelect : this.mobileSort, this.defaultEvent);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: _vm.$table.mobileSortClasses },
    [
      _c(
        "o-field",
        [
          _vm.sortMultiple
            ? _c(
                "o-select",
                {
                  attrs: { expanded: "" },
                  model: {
                    value: _vm.sortMultipleSelect,
                    callback: function($$v) {
                      _vm.sortMultipleSelect = $$v;
                    },
                    expression: "sortMultipleSelect"
                  }
                },
                _vm._l(_vm.sortableColumns, function(column, index) {
                  return _c(
                    "option",
                    { key: index, domProps: { value: column } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.getLabel(column)) +
                          "\n                "
                      ),
                      _vm.getSortingObjectOfColumn(column)
                        ? [
                            _vm.columnIsDesc(column)
                              ? [
                                  _vm._v(
                                    "\n                        ↓\n                    "
                                  )
                                ]
                              : [
                                  _vm._v(
                                    "\n                        ↑\n                    "
                                  )
                                ]
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                }),
                0
              )
            : _c(
                "o-select",
                {
                  attrs: { expanded: "" },
                  model: {
                    value: _vm.mobileSort,
                    callback: function($$v) {
                      _vm.mobileSort = $$v;
                    },
                    expression: "mobileSort"
                  }
                },
                [
                  _vm.placeholder
                    ? [
                        _c(
                          "option",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showPlaceholder,
                                expression: "showPlaceholder"
                              }
                            ],
                            attrs: { selected: "", disabled: "", hidden: "" },
                            domProps: { value: {} }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.placeholder) +
                                "\n                "
                            )
                          ]
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.sortableColumns, function(column, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: column } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(column.label) +
                            "\n            "
                        )
                      ]
                    )
                  })
                ],
                2
              ),
          _vm._v(" "),
          _vm.sortMultiple && _vm.sortMultipleData.length > 0
            ? [
                _c(
                  "o-button",
                  { attrs: { variant: "primary" }, on: { click: _vm.sort } },
                  [
                    _c("o-icon", {
                      class:
                        ((_obj = {}),
                        (_obj[
                          _vm.$table.iconSortDescClasses
                        ] = _vm.columnIsDesc(_vm.sortMultipleSelect)),
                        _obj),
                      attrs: {
                        icon: _vm.sortIcon,
                        pack: _vm.iconPack,
                        size: _vm.sortIconSize,
                        both: ""
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "o-button",
                  {
                    attrs: { variant: "primary" },
                    on: { click: _vm.removePriority }
                  },
                  [
                    _c("o-icon", {
                      attrs: {
                        icon: "delete",
                        size: _vm.sortIconSize,
                        both: ""
                      }
                    })
                  ],
                  1
                )
              ]
            : !_vm.sortMultiple
            ? _c(
                "o-button",
                { attrs: { variant: "primary" }, on: { click: _vm.sort } },
                [
                  _c("o-icon", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.currentSortColumn === _vm.mobileSort,
                        expression: "currentSortColumn === mobileSort"
                      }
                    ],
                    class: _vm.$table.iconSortClasses(),
                    attrs: {
                      icon: _vm.sortIcon,
                      pack: _vm.iconPack,
                      size: _vm.sortIconSize,
                      both: ""
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

var script$1 = {
  name: 'OTableColumn',
  inject: {
    $table: {
      name: '$table',
      default: false
    }
  },
  props: {
    label: String,
    customKey: [String, Number],
    field: String,
    meta: [String, Number, Boolean, Function, Object, Array],
    width: [Number, String],
    numeric: Boolean,
    centered: Boolean,
    searchable: Boolean,
    sortable: Boolean,
    visible: {
      type: Boolean,
      default: true
    },
    subheading: [String, Number],
    customSort: Function,
    sticky: Boolean,
    headerSelectable: Boolean,
    headerClass: String,
    cellClass: String
  },
  data: function data() {
    return {
      newKey: this.customKey || this.label
    };
  },
  computed: {
    style: function style() {
      return {
        width: toCssDimension(this.width)
      };
    },
    hasDefaultSlot: function hasDefaultSlot() {
      return !!this.$scopedSlots.default;
    },

    /**
     * Return if column header is un-selectable
     */
    isHeaderUnselectable: function isHeaderUnselectable() {
      return !this.headerSelectable && this.sortable;
    }
  },
  created: function created() {
    if (!this.$table) {
      this.$destroy();
      throw new Error('You should wrap oTableColumn on a oTable');
    }

    this.$table.refreshSlots();
  },
  render: function render() {
    // renderless
    return null;
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    {},
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$2 = {
  name: 'OTablePagination',
  props: {
    paginated: Boolean,
    total: [Number, String],
    perPage: [Number, String],
    currentPage: [Number, String],
    paginationSimple: Boolean,
    paginationSize: String,
    rounded: Boolean,
    iconPack: String,
    rootClass: [String, Array, Object],
    ariaNextLabel: String,
    ariaPreviousLabel: String,
    ariaPageLabel: String,
    ariaCurrentLabel: String
  },
  data: function data() {
    return {
      newCurrentPage: this.currentPage
    };
  },
  watch: {
    currentPage: function currentPage(newVal) {
      this.newCurrentPage = newVal;
    }
  },
  methods: {
    /**
    * Paginator change listener.
    */
    pageChanged: function pageChanged(page) {
      this.newCurrentPage = page > 0 ? page : 1;
      this.$emit('update:currentPage', this.newCurrentPage);
      this.$emit('page-change', this.newCurrentPage);
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: _vm.rootClass }, [
    _c("div", [_vm._t("default")], 2),
    _vm._v(" "),
    _c("div", [
      _vm.paginated
        ? _c(
            "div",
            [
              _c("o-pagination", {
                attrs: {
                  "icon-pack": _vm.iconPack,
                  total: _vm.total,
                  "per-page": _vm.perPage,
                  simple: _vm.paginationSimple,
                  size: _vm.paginationSize,
                  current: _vm.newCurrentPage,
                  rounded: _vm.rounded,
                  "aria-next-label": _vm.ariaNextLabel,
                  "aria-previous-label": _vm.ariaPreviousLabel,
                  "aria-page-label": _vm.ariaPageLabel,
                  "aria-current-label": _vm.ariaCurrentLabel
                },
                on: { change: _vm.pageChanged }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

var _components$1;
/**
 * Tabulated data are sometimes needed, it's even better when it's responsive
 * @displayName Table
 * @example ./examples/Table.md
 * @style _table.scss
 */

var script$3 = {
  name: 'OTable',
  components: (_components$1 = {}, _defineProperty(_components$1, __vue_component__$4.name, __vue_component__$4), _defineProperty(_components$1, __vue_component__$8.name, __vue_component__$8), _defineProperty(_components$1, __vue_component__$6.name, __vue_component__$6), _defineProperty(_components$1, __vue_component__$9.name, __vue_component__$9), _defineProperty(_components$1, __vue_component__$a.name, __vue_component__$a), _defineProperty(_components$1, __vue_component__$b.name, __vue_component__$b), _defineProperty(_components$1, SlotComponent.name, SlotComponent), _defineProperty(_components$1, __vue_component__.name, __vue_component__), _defineProperty(_components$1, __vue_component__$1.name, __vue_component__$1), _defineProperty(_components$1, __vue_component__$2.name, __vue_component__$2), _components$1),
  mixins: [BaseComponentMixin],
  inheritAttrs: false,
  provide: function provide() {
    return {
      $table: this
    };
  },
  props: {
    /** Table data */
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /** Table columns */
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /** Border to all cells */
    bordered: Boolean,

    /** Whether table is striped */
    striped: Boolean,

    /** Makes the cells narrower */
    narrowed: Boolean,

    /** Rows are highlighted when hovering */
    hoverable: Boolean,

    /** Loading state */
    loading: Boolean,

    /** Allow row details  */
    detailed: Boolean,

    /** Rows can be checked (multiple), checked rows will have a .is-checked class if you want to style */
    checkable: Boolean,

    /** Show check/uncheck all checkbox in table header when checkable */
    headerCheckable: {
      type: Boolean,
      default: true
    },

    /**
     * Position of the checkbox (if checkable is true)
     * @values left, right
     */
    checkboxPosition: {
      type: String,
      default: 'left',
      validator: function validator(value) {
        return ['left', 'right'].indexOf(value) >= 0;
      }
    },

    /** Set which row is selected, use the .sync modifier to make it two-way binding */
    selected: Object,

    /** Custom method to verify if a row is selectable, works when is selected. */
    isRowSelectable: {
      type: Function,
      default: function _default() {
        return true;
      }
    },

    /** Table can be focused and user can navigate with keyboard arrows (require selected.sync) and rows are highlighted when hovering */
    focusable: Boolean,

    /** Custom method to verify if row is checked, works when is checkable. Useful for backend pagination */
    customIsChecked: Function,

    /** Custom method to verify if a row is checkable, works when is checkable */
    isRowCheckable: {
      type: Function,
      default: function _default() {
        return true;
      }
    },

    /** Set which rows are checked, use the .sync modifier to make it two-way binding */
    checkedRows: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /** Rows appears as cards on mobile (collapse rows) */
    mobileCards: {
      type: Boolean,
      default: true
    },

    /** Sets the default sort column and order — e.g. ['first_name', 'desc']	 */
    defaultSort: [String, Array],

    /**
     * Sets the default sort column direction on the first click
     * @values asc, desc
     */
    defaultSortDirection: {
      type: String,
      default: 'asc'
    },

    /** Sets the header sorting icon */
    sortIcon: {
      type: String,
      default: function _default() {
        return getValueByPath(config, 'table.sortIcon', 'arrow-up');
      }
    },

    /**
     * Sets the size of the sorting icon
     * @values small, medium, large
     */
    sortIconSize: {
      type: String,
      default: function _default() {
        return getValueByPath(config, 'table.sortIconSize', 'small');
      }
    },

    /** Adds multiple column sorting */
    sortMultiple: {
      type: Boolean,
      default: false
    },

    /** Used in combination with backend-sorting */
    sortMultipleData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Adds a key which will be required for multi column sorting to work. Will always be enabled if null is selected (default). Requres sort-multiple
     * @values null, shiftKey, altKey, ctrlKey
     */
    sortMultipleKey: {
      type: String,
      default: null
    },

    /** Adds pagination to the table */
    paginated: Boolean,

    /** Current page of table data (if paginated), use the .sync modifier to make it two-way binding */
    currentPage: {
      type: Number,
      default: 1
    },

    /** How many rows per page (if paginated) */
    perPage: {
      type: [Number, String],
      default: function _default() {
        return getValueByPath(config, 'table.perPage', 20);
      }
    },

    /** Allow chevron icon and column to be visible */
    showDetailIcon: {
      type: Boolean,
      default: true
    },

    /**
     * Pagination position (if paginated)
     * @values bottom, top, bot
     */
    paginationPosition: {
      type: String,
      default: function _default() {
        return getValueByPath(config, 'table.paginationPosition', 'bottom');
      },
      validator: function validator(value) {
        return ['bottom', 'top', 'both'].indexOf(value) >= 0;
      }
    },

    /** Columns won't be sorted with Javascript, use with sort event to sort in your backend */
    backendSorting: Boolean,

    /** Columns won't be filtered with Javascript, use with searchable prop to the columns to filter in your backend */
    backendFiltering: Boolean,

    /** Add a class to row based on the return */
    rowClass: {
      type: Function,
      default: function _default() {
        return '';
      }
    },

    /** Allow pre-defined opened details. Ideal to open details via vue-router. (A unique key is required; check detail-key prop) */
    openedDetailed: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /** Controls the visibility of the trigger that toggles the detailed rows. */
    hasDetailedVisible: {
      type: Function,
      default: function _default() {
        return true;
      }
    },

    /** Use a unique key of your data Object when use detailed or opened detailed. (id recommended) */
    detailKey: {
      type: String,
      default: ''
    },

    /** Custom style on details */
    customDetailRow: {
      type: Boolean,
      default: false
    },

    /** Rows won't be paginated with Javascript, use with page-change event to paginate in your backend */
    backendPagination: Boolean,

    /** Total number of table data if backend-pagination is enabled */
    total: {
      type: [Number, String],
      default: 0
    },

    /** Icon pack to use */
    iconPack: String,

    /** Text when nothing is selected */
    mobileSortPlaceholder: String,

    /** Use a unique key of your data Object for each row. Useful if your data prop has dynamic indices. (id recommended) */
    customRowKey: String,

    /** Allows rows to be draggable */
    draggable: {
      type: Boolean,
      default: false
    },

    /** Add a horizontal scrollbar when table is too wide */
    scrollable: Boolean,
    ariaNextLabel: String,
    ariaPreviousLabel: String,
    ariaPageLabel: String,
    ariaCurrentLabel: String,

    /** Show a sticky table header */
    stickyHeader: Boolean,

    /** Table fixed height */
    height: [Number, String],

    /** Add a native event to filter */
    filtersEvent: {
      type: String,
      default: ''
    },

    /** Force to show table with cards layout */
    cardLayout: Boolean,

    /** Show header */
    showHeader: {
      type: Boolean,
      default: function _default() {
        return getValueByPath(config, 'table.showHeader', true);
      }
    },
    rootClass: String,
    wrapperClass: String,
    footerClass: String,
    emptyClass: String,
    detailedClass: String,
    detailedChevronClass: String,
    detailedIconExpandedClass: String,
    borderedClass: String,
    stripedClass: String,
    narrowClass: String,
    hoverableClass: String,
    thWrapClass: String,
    thContentClass: String,
    thRightClass: String,
    thCenteredClass: String,
    thStickyClass: String,
    thCheckboxClass: String,
    thCurrentSortClass: String,
    thSortableClass: String,
    thUnselectableClass: String,
    thDetailedClass: String,
    tdRightClass: String,
    tdCenteredClass: String,
    tdStickyClass: String,
    tdCheckboxCellClass: String,
    tdSelectedClass: String,
    subheadingClass: String,
    stickyHeaderClass: String,
    mobileCardsClass: String,
    cardsClass: String,
    scrollableClass: String,
    mobileSortClass: String,
    iconSortDescClass: String,
    iconSortClass: String,
    iconSortInvisibleClass: String,
    paginationWrapperClass: String
  },
  data: function data() {
    return {
      sortMultipleDataLocal: [],
      getValueByPath: getValueByPath,
      visibleDetailRows: this.openedDetailed,
      newData: this.data,
      newDataTotal: this.backendPagination ? this.total : this.data.length,
      newCheckedRows: _toConsumableArray(this.checkedRows),
      lastCheckedRowIndex: null,
      newCurrentPage: this.currentPage,
      currentSortColumn: {},
      isAsc: true,
      filters: {},
      defaultSlots: [],
      firstTimeSort: true // Used by first time initSort

    };
  },
  computed: {
    rootClasses: function rootClasses() {
      return [this.computedClass('table', 'rootClass', 'o-table')];
    },
    tableClasses: function tableClasses() {
      return [_defineProperty({}, this.computedClass('table', 'borderedClass', 'o-table-bordered'), this.bordered), _defineProperty({}, this.computedClass('table', 'stripedClass', 'o-table-striped'), this.striped), _defineProperty({}, this.computedClass('table', 'narrowClass', 'o-table-narrow'), this.narrowed), _defineProperty({}, this.computedClass('table', 'hoverableClass', 'o-table-hoverable'), (this.hoverable || this.focusable) && this.visibleData.length)];
    },
    tableWrapperClasses: function tableWrapperClasses() {
      return [this.computedClass('table', 'wrapperClass', 'o-table-wrapper'), _defineProperty({}, this.computedClass('table', 'mobileCardsClass', 'o-table-mobile-cards'), this.mobileCards), _defineProperty({}, this.computedClass('table', 'stickyHeaderClass', 'o-table-sticky-header'), this.stickyHeader), _defineProperty({}, this.computedClass('table', 'cardsClass', 'o-table-cards'), this.cardLayout), _defineProperty({}, this.computedClass('table', 'scrollableClass', 'o-table-scrollable'), this.isScrollable)];
    },
    footerClasses: function footerClasses() {
      return [this.computedClass('table', 'footerClass', 'o-table-footer')];
    },
    emptyClasses: function emptyClasses() {
      return [this.computedClass('table', 'emptyClass', 'o-table-empty')];
    },
    thContentClasses: function thContentClasses() {
      return [this.computedClass('table', 'thContentClass', 'o-table-th-content')];
    },
    thCheckboxClasses: function thCheckboxClasses() {
      return [this.computedClass('table', 'thCheckboxClass', 'o-table-th-checkbox')];
    },
    thDetailedClasses: function thDetailedClasses() {
      return [this.computedClass('table', 'thDetailedClass', 'o-table-th-detail')];
    },
    tdCheckboxCellClasses: function tdCheckboxCellClasses() {
      return [this.computedClass('table', 'tdCheckboxCellClass', 'o-table-checkbox-cell')];
    },
    detailedClasses: function detailedClasses() {
      return [this.computedClass('table', 'detailedClass', 'o-table-detail')];
    },
    detailedChevronClasses: function detailedChevronClasses() {
      return [this.computedClass('table', 'detailedChevronClass', 'o-table-chevron-cell')];
    },
    subheadingClasses: function subheadingClasses() {
      return [this.computedClass('table', 'subheadingClass', 'o-table-subheading')];
    },
    mobileSortClasses: function mobileSortClasses() {
      return [this.computedClass('table', 'mobileSortClass', 'o-table-mobile-sort')];
    },
    paginationWrapperClasses: function paginationWrapperClasses() {
      return [this.computedClass('table', 'paginationWrapperClass', 'o-pagination-wrapper')];
    },
    iconSortDescClasses: function iconSortDescClasses() {
      return [_defineProperty({}, this.computedClass('table', 'iconSortDescClass', 'o-icon-sort-desc'), !this.isAsc)];
    },
    tableWrapperStyle: function tableWrapperStyle() {
      return {
        height: toCssDimension(this.height)
      };
    },

    /**
    * Splitted data based on the pagination.
    */
    visibleData: function visibleData() {
      if (!this.paginated) return this.newData;
      var currentPage = this.newCurrentPage;
      var perPage = this.perPage;

      if (this.newData.length <= perPage) {
        return this.newData;
      } else {
        var start = (currentPage - 1) * perPage;
        var end = parseInt(start, 10) + parseInt(perPage, 10);
        return this.newData.slice(start, end);
      }
    },
    visibleColumns: function visibleColumns() {
      if (!this.newColumns) return this.newColumns;
      return this.newColumns.filter(function (column) {
        return column.visible || column.visible === undefined;
      });
    },

    /**
    * Check if all rows in the page are checked.
    */
    isAllChecked: function isAllChecked() {
      var _this = this;

      var validVisibleData = this.visibleData.filter(function (row) {
        return _this.isRowCheckable(row);
      });
      if (validVisibleData.length === 0) return false;
      var isAllChecked = validVisibleData.some(function (currentVisibleRow) {
        return indexOf(_this.newCheckedRows, currentVisibleRow, _this.customIsChecked) < 0;
      });
      return !isAllChecked;
    },

    /**
    * Check if all rows in the page are checkable.
    */
    isAllUncheckable: function isAllUncheckable() {
      var _this2 = this;

      var validVisibleData = this.visibleData.filter(function (row) {
        return _this2.isRowCheckable(row);
      });
      return validVisibleData.length === 0;
    },

    /**
    * Check if has any sortable column.
    */
    hasSortablenewColumns: function hasSortablenewColumns() {
      return this.newColumns.some(function (column) {
        return column.sortable;
      });
    },

    /**
    * Check if has any searchable column.
    */
    hasSearchablenewColumns: function hasSearchablenewColumns() {
      return this.newColumns.some(function (column) {
        return column.searchable;
      });
    },

    /**
    * Check if has any column using subheading.
    */
    hasCustomSubheadings: function hasCustomSubheadings() {
      if (this.$scopedSlots && this.$scopedSlots.subheading) return true;
      return this.newColumns.some(function (column) {
        return column.subheading || column.$scopedSlots && column.$scopedSlots.subheading;
      });
    },

    /**
    * Return total column count based if it's checkable or expanded
    */
    columnCount: function columnCount() {
      var count = this.newColumns.length;
      count += this.checkable ? 1 : 0;
      count += this.detailed && this.showDetailIcon ? 1 : 0;
      return count;
    },

    /**
    * return if detailed row tabled
    * will be with chevron column & icon or not
    */
    showDetailRowIcon: function showDetailRowIcon() {
      return this.detailed && this.showDetailIcon;
    },

    /**
    * return if scrollable table
    */
    isScrollable: function isScrollable() {
      if (this.scrollable) return true;
      if (!this.newColumns) return false;
      return this.newColumns.some(function (column) {
        return column.sticky;
      });
    },
    newColumns: function newColumns() {
      var _this3 = this;

      if (this.columns && this.columns.length) {
        return this.columns.map(function (column) {
          var TableColumnComponent = VueInstance.extend(__vue_component__$1);
          var component = new TableColumnComponent({
            parent: _this3,
            propsData: column
          });
          component.$scopedSlots = {
            default: function _default(props) {
              var vnode = component.$createElement('span', {
                domProps: {
                  innerHTML: getValueByPath(props.row, column.field)
                }
              });
              return [vnode];
            }
          };
          return component;
        });
      }

      return this.defaultSlots.filter(function (vnode) {
        return vnode.componentInstance && vnode.componentInstance.$options && vnode.componentInstance.$options.name === 'OTableColumn';
      }).map(function (vnode) {
        return vnode.componentInstance;
      });
    },
    sortMultipleDataComputed: function sortMultipleDataComputed() {
      return this.backendSorting ? this.sortMultipleData : this.sortMultipleDataLocal;
    }
  },
  watch: {
    /**
    * When data prop change:
    *   1. Update internal value.
    *   2. Filter data if it's not backend-filtered.
    *   3. Sort again if it's not backend-sorted.
    *   4. Set new total if it's not backend-paginated.
    */
    data: function data(value) {
      var _this4 = this;

      this.newData = value;

      if (!this.backendFiltering) {
        this.newData = value.filter(function (row) {
          return _this4.isRowFiltered(row);
        });
      }

      if (!this.backendSorting) {
        this.sort(this.currentSortColumn, true);
      }

      if (!this.backendPagination) {
        this.newDataTotal = this.newData.length;
      }
    },

    /**
    * When Pagination total change, update internal total
    * only if it's backend-paginated.
    */
    total: function total(newTotal) {
      if (!this.backendPagination) return;
      this.newDataTotal = newTotal;
    },
    currentPage: function currentPage(newValue) {
      this.newCurrentPage = newValue;
    },

    /**
    * When checkedRows prop change, update internal value without
    * mutating original data.
    */
    checkedRows: function checkedRows(rows) {
      this.newCheckedRows = _toConsumableArray(rows);
    },
    filters: {
      handler: function handler(value) {
        var _this5 = this;

        if (this.backendFiltering) {
          this.$emit('filters-change', value);
        } else {
          this.newData = this.data.filter(function (row) {
            return _this5.isRowFiltered(row);
          });

          if (!this.backendPagination) {
            this.newDataTotal = this.newData.length;
          }

          if (!this.backendSorting) {
            if (this.sortMultiple && this.sortMultipleDataLocal && this.sortMultipleDataLocal.length > 0) {
              this.doSortMultiColumn();
            } else if (Object.keys(this.currentSortColumn).length > 0) {
              this.doSortSingleColumn(this.currentSortColumn);
            }
          }
        }
      },
      deep: true
    },

    /**
    * When the user wants to control the detailed rows via props.
    * Or wants to open the details of certain row with the router for example.
    */
    openedDetailed: function openedDetailed(expandedRows) {
      this.visibleDetailRows = expandedRows;
    }
  },
  methods: {
    thWrapClasses: function thWrapClasses(column) {
      return [this.computedClass('table', 'thWrapClass', 'o-table-th-wrap'), _defineProperty({}, this.computedClass('table', 'thRightClass', 'o-table-th-right'), column.numeric), _defineProperty({}, this.computedClass('table', 'thCenteredClass', 'o-table-th-centered'), column.centered)];
    },
    thClasses: function thClasses(column) {
      return [column.headerClass, _defineProperty({}, this.computedClass('table', 'thCurrentSortClass', 'o-table-th-current-sort'), !this.sortMultiple && this.currentSortColumn === column), _defineProperty({}, this.computedClass('table', 'thSortableClass', 'o-table-th-sortable'), column.sortable), _defineProperty({}, this.computedClass('table', 'thUnselectableClass', 'o-table-th-unselectable'), column.isHeaderUnselectable)].concat(_toConsumableArray(this.thStickyClasses(column)));
    },
    thStickyClasses: function thStickyClasses(column) {
      return [_defineProperty({}, this.computedClass('table', 'thStickyClass', 'o-table-th-sticky'), column.sticky)];
    },
    rowClasses: function rowClasses(row, index) {
      return [this.rowClass(row, index), _defineProperty({}, this.computedClass('table', 'tdSelectedClass', 'o-table-row-selected'), row === this.selected)];
    },
    iconSortClasses: function iconSortClasses(column) {
      return [this.computedClass('table', 'iconSortClass', 'o-icon-sort'), _defineProperty({}, this.computedClass('table', 'iconSortInvisibleClass', 'o-icon-sort-invisible'), column && this.currentSortColumn !== column)].concat(_toConsumableArray(this.iconSortDescClasses));
    },
    iconSortMultipleClasses: function iconSortMultipleClasses(column) {
      return [_defineProperty({}, this.computedClass('table', 'iconSortDescClass', 'o-icon-sort-desc'), this.sortMultipleDataComputed.filter(function (i) {
        return i.field === column.field;
      })[0].order === 'desc')];
    },
    columnClasses: function columnClasses(column) {
      return [column.cellClass, _defineProperty({}, this.computedClass('table', 'tdRightClass', 'o-table-td-right'), column.numeric && !column.centered), _defineProperty({}, this.computedClass('table', 'tdCenteredClass', 'o-table-td-centered'), column.centered), _defineProperty({}, this.computedClass('table', 'tdStickyClass', 'o-table-td-sticky'), column.sticky)];
    },
    detailedIconExpandedClasses: function detailedIconExpandedClasses(row) {
      return [_defineProperty({}, this.computedClass('table', 'detailedIconExpandedClass', 'o-table-detail-icon-expanded'), this.isVisibleDetailRow(row))];
    },
    onFiltersEvent: function onFiltersEvent(event) {
      this.$emit("filters-event-".concat(this.filtersEvent), {
        event: event,
        filters: this.filters
      });
    },
    findIndexOfSortData: function findIndexOfSortData(column) {
      var sortObj = this.sortMultipleDataComputed.filter(function (i) {
        return i.field === column.field;
      })[0];
      return this.sortMultipleDataComputed.indexOf(sortObj) + 1;
    },
    removeSortingPriority: function removeSortingPriority(column) {
      if (this.backendSorting) {
        this.$emit('sorting-priority-removed', column.field);
      } else {
        this.sortMultipleDataLocal = this.sortMultipleDataLocal.filter(function (priority) {
          return priority.field !== column.field;
        });
        var formattedSortingPriority = this.sortMultipleDataLocal.map(function (i) {
          return (i.order && i.order === 'desc' ? '-' : '') + i.field;
        });
        this.newData = multiColumnSort(this.newData, formattedSortingPriority);
      }
    },
    resetMultiSorting: function resetMultiSorting() {
      this.sortMultipleDataLocal = [];
      this.currentSortColumn = {};
      this.newData = this.data;
    },

    /**
    * Sort an array by key without mutating original data.
    * Call the user sort function if it was passed.
    */
    sortBy: function sortBy(array, key, fn, isAsc) {
      var sorted = []; // Sorting without mutating original data

      if (fn && typeof fn === 'function') {
        sorted = _toConsumableArray(array).sort(function (a, b) {
          return fn(a, b, isAsc);
        });
      } else {
        sorted = _toConsumableArray(array).sort(function (a, b) {
          // Get nested values from objects
          var newA = getValueByPath(a, key);
          var newB = getValueByPath(b, key); // sort boolean type

          if (typeof newA === 'boolean' && typeof newB === 'boolean') {
            return isAsc ? newA - newB : newB - newA;
          }

          if (!newA && newA !== 0) return 1;
          if (!newB && newB !== 0) return -1;
          if (newA === newB) return 0;
          newA = typeof newA === 'string' ? newA.toUpperCase() : newA;
          newB = typeof newB === 'string' ? newB.toUpperCase() : newB;
          return isAsc ? newA > newB ? 1 : -1 : newA > newB ? -1 : 1;
        });
      }

      return sorted;
    },
    sortMultiColumn: function sortMultiColumn(column) {
      this.currentSortColumn = {};

      if (!this.backendSorting) {
        var existingPriority = this.sortMultipleDataLocal.filter(function (i) {
          return i.field === column.field;
        })[0];

        if (existingPriority) {
          existingPriority.order = existingPriority.order === 'desc' ? 'asc' : 'desc';
        } else {
          this.sortMultipleDataLocal.push({
            field: column.field,
            order: column.isAsc
          });
        }

        this.doSortMultiColumn();
      }
    },
    doSortMultiColumn: function doSortMultiColumn() {
      var formattedSortingPriority = this.sortMultipleDataLocal.map(function (i) {
        return (i.order && i.order === 'desc' ? '-' : '') + i.field;
      });
      this.newData = multiColumnSort(this.newData, formattedSortingPriority);
    },

    /**
    * Sort the column.
    * Toggle current direction on column if it's sortable
    * and not just updating the prop.
    */
    sort: function sort(column) {
      var updatingData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if ( // if backend sorting is enabled, just emit the sort press like usual
      // if the correct key combination isnt pressed, sort like usual
      !this.backendSorting && this.sortMultiple && (this.sortMultipleKey && event[this.sortMultipleKey] || !this.sortMultipleKey)) {
        this.sortMultiColumn(column);
      } else {
        if (!column || !column.sortable) return; // sort multiple is enabled but the correct key combination isnt pressed so reset

        if (this.sortMultiple) {
          this.sortMultipleDataLocal = [];
        }

        if (!updatingData) {
          this.isAsc = column === this.currentSortColumn ? !this.isAsc : this.defaultSortDirection.toLowerCase() !== 'desc';
        }

        if (!this.firstTimeSort) {
          this.$emit('sort', column.field, this.isAsc ? 'asc' : 'desc', event);
        }

        if (!this.backendSorting) {
          this.doSortSingleColumn(column);
        }

        this.currentSortColumn = column;
      }
    },
    doSortSingleColumn: function doSortSingleColumn(column) {
      this.newData = this.sortBy(this.newData, column.field, column.customSort, this.isAsc);
    },

    /**
    * Check if the row is checked (is added to the array).
    */
    isRowChecked: function isRowChecked(row) {
      return indexOf(this.newCheckedRows, row, this.customIsChecked) >= 0;
    },

    /**
    * Remove a checked row from the array.
    */
    removeCheckedRow: function removeCheckedRow(row) {
      var index = indexOf(this.newCheckedRows, row, this.customIsChecked);

      if (index >= 0) {
        this.newCheckedRows.splice(index, 1);
      }
    },

    /**
    * Header checkbox click listener.
    * Add or remove all rows in current page.
    */
    checkAll: function checkAll() {
      var _this6 = this;

      var isAllChecked = this.isAllChecked;
      this.visibleData.forEach(function (currentRow) {
        if (_this6.isRowCheckable(currentRow)) {
          _this6.removeCheckedRow(currentRow);
        }

        if (!isAllChecked) {
          if (_this6.isRowCheckable(currentRow)) {
            _this6.newCheckedRows.push(currentRow);
          }
        }
      });
      this.$emit('check', this.newCheckedRows);
      this.$emit('check-all', this.newCheckedRows); // Emit checked rows to update user variable

      this.$emit('update:checkedRows', this.newCheckedRows);
    },

    /**
    * Row checkbox click listener.
    */
    checkRow: function checkRow(row, index, event) {
      if (!this.isRowCheckable(row)) return;
      var lastIndex = this.lastCheckedRowIndex;
      this.lastCheckedRowIndex = index;

      if (event.shiftKey && lastIndex !== null && index !== lastIndex) {
        this.shiftCheckRow(row, index, lastIndex);
      } else if (!this.isRowChecked(row)) {
        this.newCheckedRows.push(row);
      } else {
        this.removeCheckedRow(row);
      }

      this.$emit('check', this.newCheckedRows, row); // Emit checked rows to update user variable

      this.$emit('update:checkedRows', this.newCheckedRows);
    },

    /**
     * Check row when shift is pressed.
     */
    shiftCheckRow: function shiftCheckRow(row, index, lastCheckedRowIndex) {
      var _this7 = this;

      // Get the subset of the list between the two indicies
      var subset = this.visibleData.slice(Math.min(index, lastCheckedRowIndex), Math.max(index, lastCheckedRowIndex) + 1); // Determine the operation based on the state of the clicked checkbox

      var shouldCheck = !this.isRowChecked(row);
      subset.forEach(function (item) {
        _this7.removeCheckedRow(item);

        if (shouldCheck && _this7.isRowCheckable(item)) {
          _this7.newCheckedRows.push(item);
        }
      });
    },

    /**
    * Row click listener.
    * Emit all necessary events.
    */
    selectRow: function selectRow(row, index) {
      this.$emit('click', row, index);
      if (this.selected === row) return;
      if (!this.isRowSelectable(row)) return; // Emit new and old row

      this.$emit('select', row, this.selected); // Emit new row to update user variable

      this.$emit('update:selected', row);
    },

    /**
    * Toggle to show/hide details slot
    */
    toggleDetails: function toggleDetails(obj) {
      var found = this.isVisibleDetailRow(obj);

      if (found) {
        this.closeDetailRow(obj);
        this.$emit('details-close', obj);
      } else {
        this.openDetailRow(obj);
        this.$emit('details-open', obj);
      } // Syncs the detailed rows with the parent component


      this.$emit('update:openedDetailed', this.visibleDetailRows);
    },
    openDetailRow: function openDetailRow(obj) {
      var index = this.handleDetailKey(obj);
      this.visibleDetailRows.push(index);
    },
    closeDetailRow: function closeDetailRow(obj) {
      var index = this.handleDetailKey(obj);
      var i = this.visibleDetailRows.indexOf(index);
      this.visibleDetailRows.splice(i, 1);
    },
    isVisibleDetailRow: function isVisibleDetailRow(obj) {
      var index = this.handleDetailKey(obj);
      var result = this.visibleDetailRows.indexOf(index) >= 0;
      return result;
    },
    isActiveDetailRow: function isActiveDetailRow(row) {
      return this.detailed && !this.customDetailRow && this.isVisibleDetailRow(row);
    },
    isActiveCustomDetailRow: function isActiveCustomDetailRow(row) {
      return this.detailed && this.customDetailRow && this.isVisibleDetailRow(row);
    },
    isRowFiltered: function isRowFiltered(row) {
      for (var key in this.filters) {
        // remove key if empty
        if (!this.filters[key]) {
          delete this.filters[key];
          return true;
        }

        var value = this.getValueByPath(row, key);
        if (value == null) return false;

        if (Number.isInteger(value)) {
          if (value !== Number(this.filters[key])) return false;
        } else {
          var re = new RegExp(this.filters[key], 'i');
          if (typeof value === 'boolean') value = "".concat(value);
          if (!value.match(re)) return false;
        }
      }

      return true;
    },

    /**
    * When the detailKey is defined we use the object[detailKey] as index.
    * If not, use the object reference by default.
    */
    handleDetailKey: function handleDetailKey(index) {
      var key = this.detailKey;
      return !key.length || !index ? index : index[key];
    },
    checkPredefinedDetailedRows: function checkPredefinedDetailedRows() {
      var defaultExpandedRowsDefined = this.openedDetailed.length > 0;

      if (defaultExpandedRowsDefined && !this.detailKey.length) {
        throw new Error('If you set a predefined opened-detailed, you must provide a unique key using the prop "detail-key"');
      }
    },

    /**
    * Call initSort only first time (For example async data).
    */
    checkSort: function checkSort() {
      if (this.newColumns.length && this.firstTimeSort) {
        this.initSort();
        this.firstTimeSort = false;
      } else if (this.newColumns.length) {
        if (Object.keys(this.currentSortColumn).length > 0) {
          for (var i = 0; i < this.newColumns.length; i++) {
            if (this.newColumns[i].field === this.currentSortColumn.field) {
              this.currentSortColumn = this.newColumns[i];
              break;
            }
          }
        }
      }
    },

    /**
    * Check if footer slot has custom content.
    */
    hasCustomFooterSlot: function hasCustomFooterSlot() {
      if (this.$slots.footer.length > 1) return true;
      var tag = this.$slots.footer[0].tag;
      if (tag !== 'th' && tag !== 'td') return false;
      return true;
    },

    /**
    * Check if bottom-left slot exists.
    */
    hasBottomLeftSlot: function hasBottomLeftSlot() {
      return typeof this.$slots['bottom-left'] !== 'undefined';
    },

    /**
    * Table arrow keys listener, change selection.
    */
    pressedArrow: function pressedArrow(pos) {
      if (!this.visibleData.length) return;
      var index = this.visibleData.indexOf(this.selected) + pos; // Prevent from going up from first and down from last

      index = index < 0 ? 0 : index > this.visibleData.length - 1 ? this.visibleData.length - 1 : index;
      var row = this.visibleData[index];

      if (!this.isRowSelectable(row)) {
        var newIndex = null;

        if (pos > 0) {
          for (var i = index; i < this.visibleData.length && newIndex === null; i++) {
            if (this.isRowSelectable(this.visibleData[i])) newIndex = i;
          }
        } else {
          for (var _i = index; _i >= 0 && newIndex === null; _i--) {
            if (this.isRowSelectable(this.visibleData[_i])) newIndex = _i;
          }
        }

        if (newIndex >= 0) {
          this.selectRow(this.visibleData[newIndex]);
        }
      } else {
        this.selectRow(row);
      }
    },

    /**
    * Focus table element if has selected prop.
    */
    focus: function focus() {
      if (!this.focusable) return;
      this.$el.querySelector('table').focus();
    },

    /**
    * Initial sorted column based on the default-sort prop.
    */
    initSort: function initSort() {
      var _this8 = this;

      if (!this.backendSorting) {
        if (this.sortMultiple && this.sortMultipleData) {
          this.sortMultipleData.forEach(function (column) {
            _this8.sortMultiColumn(column);
          });
        } else {
          if (!this.defaultSort) return;
          var sortField = '';
          var sortDirection = this.defaultSortDirection;

          if (Array.isArray(this.defaultSort)) {
            sortField = this.defaultSort[0];

            if (this.defaultSort[1]) {
              sortDirection = this.defaultSort[1];
            }
          } else {
            sortField = this.defaultSort;
          }

          var sortColumn = this.newColumns.filter(function (column) {
            return column.field === sortField;
          })[0];

          if (sortColumn) {
            this.isAsc = sortDirection.toLowerCase() !== 'desc';
            this.sort(sortColumn, true);
          }
        }
      }
    },

    /**
    * Emits drag start event
    */
    handleDragStart: function handleDragStart(event, row, index) {
      this.$emit('dragstart', {
        event: event,
        row: row,
        index: index
      });
    },

    /**
    * Emits drag leave event
    */
    handleDragEnd: function handleDragEnd(event, row, index) {
      this.$emit('dragend', {
        event: event,
        row: row,
        index: index
      });
    },

    /**
    * Emits drop event
    */
    handleDrop: function handleDrop(event, row, index) {
      this.$emit('drop', {
        event: event,
        row: row,
        index: index
      });
    },

    /**
    * Emits drag over event
    */
    handleDragOver: function handleDragOver(event, row, index) {
      this.$emit('dragover', {
        event: event,
        row: row,
        index: index
      });
    },

    /**
    * Emits drag leave event
    */
    handleDragLeave: function handleDragLeave(event, row, index) {
      this.$emit('dragleave', {
        event: event,
        row: row,
        index: index
      });
    },
    refreshSlots: function refreshSlots() {
      this.defaultSlots = this.$slots.default || [];
    }
  },
  mounted: function mounted() {
    this.refreshSlots();
    this.checkPredefinedDetailedRows();
    this.checkSort();
  }
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: _vm.rootClasses },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.mobileCards && _vm.hasSortablenewColumns
        ? _c("o-table-mobile-sort", {
            attrs: {
              "current-sort-column": _vm.currentSortColumn,
              "sort-multiple": _vm.sortMultiple,
              "sort-multiple-data": _vm.sortMultipleDataComputed,
              columns: _vm.newColumns,
              placeholder: _vm.mobileSortPlaceholder,
              "icon-pack": _vm.iconPack,
              "sort-icon": _vm.sortIcon,
              "sort-icon-size": _vm.sortIconSize
            },
            on: {
              sort: function(column, event) {
                return _vm.sort(column, null, event)
              },
              removePriority: function(column) {
                return _vm.removeSortingPriority(column)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.paginated &&
      (_vm.paginationPosition === "top" || _vm.paginationPosition === "both")
        ? [
            _vm._t("pagination", [
              _c(
                "o-table-pagination",
                _vm._b(
                  {
                    attrs: {
                      "per-page": _vm.perPage,
                      paginated: _vm.paginated,
                      total: _vm.newDataTotal,
                      "current-page": _vm.newCurrentPage,
                      "root-class": _vm.paginationWrapperClasses
                    },
                    on: {
                      "update:currentPage": function($event) {
                        _vm.newCurrentPage = $event;
                      },
                      "update:current-page": function($event) {
                        _vm.newCurrentPage = $event;
                      },
                      "page-change": function(event) {
                        return _vm.$emit("page-change", event)
                      }
                    }
                  },
                  "o-table-pagination",
                  _vm.$attrs,
                  false
                ),
                [_vm._t("top-left")],
                2
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.tableWrapperClasses, style: _vm.tableWrapperStyle },
        [
          _c(
            "table",
            {
              class: _vm.tableClasses,
              attrs: { tabindex: !_vm.focusable ? false : 0 },
              on: {
                keydown: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "up", 38, $event.key, [
                        "Up",
                        "ArrowUp"
                      ])
                    ) {
                      return null
                    }
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    $event.preventDefault();
                    return _vm.pressedArrow(-1)
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "down", 40, $event.key, [
                        "Down",
                        "ArrowDown"
                      ])
                    ) {
                      return null
                    }
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    $event.preventDefault();
                    return _vm.pressedArrow(1)
                  }
                ]
              }
            },
            [
              _vm.newColumns.length && _vm.showHeader
                ? _c("thead", [
                    _c(
                      "tr",
                      [
                        _vm.showDetailRowIcon
                          ? _c("th", { attrs: { width: "40px" } })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.checkable && _vm.checkboxPosition === "left"
                          ? _c(
                              "th",
                              { class: _vm.thCheckboxClasses },
                              [
                                _vm.headerCheckable
                                  ? [
                                      _c("o-checkbox", {
                                        attrs: {
                                          value: _vm.isAllChecked,
                                          disabled: _vm.isAllUncheckable
                                        },
                                        nativeOn: {
                                          change: function($event) {
                                            return _vm.checkAll($event)
                                          }
                                        }
                                      })
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.visibleColumns, function(column, index) {
                          return _c(
                            "th",
                            {
                              key: index,
                              class: _vm.thClasses(column),
                              style: column.style,
                              on: {
                                click: function($event) {
                                  $event.stopPropagation();
                                  return _vm.sort(column, null, $event)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { class: _vm.thWrapClasses(column) },
                                [
                                  column.$scopedSlots &&
                                  column.$scopedSlots.header
                                    ? [
                                        _c("o-slot-component", {
                                          attrs: {
                                            component: column,
                                            scoped: "",
                                            name: "header",
                                            tag: "span",
                                            props: {
                                              column: column,
                                              index: index
                                            }
                                          }
                                        })
                                      ]
                                    : [
                                        _c(
                                          "span",
                                          { class: _vm.thContentClasses },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(column.label) +
                                                "\n                                    "
                                            ),
                                            _vm.sortMultiple &&
                                            _vm.sortMultipleDataComputed &&
                                            _vm.sortMultipleDataComputed
                                              .length > 0 &&
                                            _vm.sortMultipleDataComputed.filter(
                                              function(i) {
                                                return i.field === column.field
                                              }
                                            ).length > 0
                                              ? [
                                                  _c("o-icon", {
                                                    class: _vm.iconSortMultipleClasses(
                                                      column
                                                    ),
                                                    attrs: {
                                                      icon: _vm.sortIcon,
                                                      pack: _vm.iconPack,
                                                      both: "",
                                                      size: _vm.sortIconSize
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.findIndexOfSortData(
                                                          column
                                                        )
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                  _c("o-button", {
                                                    attrs: {
                                                      "native-type": "button",
                                                      size: "small"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation();
                                                        return _vm.removeSortingPriority(
                                                          column
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              : _c("o-icon", {
                                                  class: _vm.iconSortClasses(
                                                    column
                                                  ),
                                                  attrs: {
                                                    icon: _vm.sortIcon,
                                                    pack: _vm.iconPack,
                                                    both: "",
                                                    size: _vm.sortIconSize
                                                  }
                                                })
                                          ],
                                          2
                                        )
                                      ]
                                ],
                                2
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.checkable && _vm.checkboxPosition === "right"
                          ? _c(
                              "th",
                              { class: _vm.thCheckboxClasses },
                              [
                                _vm.headerCheckable
                                  ? [
                                      _c("o-checkbox", {
                                        attrs: {
                                          value: _vm.isAllChecked,
                                          disabled: _vm.isAllUncheckable
                                        },
                                        nativeOn: {
                                          change: function($event) {
                                            return _vm.checkAll($event)
                                          }
                                        }
                                      })
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.hasCustomSubheadings
                      ? _c(
                          "tr",
                          { class: _vm.subheadingClasses },
                          [
                            _vm.showDetailRowIcon
                              ? _c("th", { class: _vm.thDetailedClasses })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.checkable && _vm.checkboxPosition === "left"
                              ? _c("th")
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.visibleColumns, function(column, index) {
                              return _c(
                                "th",
                                { key: index, style: column.style },
                                [
                                  _c(
                                    "div",
                                    { class: _vm.thWrapClasses({}) },
                                    [
                                      column.$scopedSlots &&
                                      column.$scopedSlots.subheading
                                        ? [
                                            _c("o-slot-component", {
                                              attrs: {
                                                component: column,
                                                scoped: "",
                                                name: "subheading",
                                                tag: "span",
                                                props: {
                                                  column: column,
                                                  index: index
                                                }
                                              }
                                            })
                                          ]
                                        : [_vm._v(_vm._s(column.subheading))]
                                    ],
                                    2
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm.checkable && _vm.checkboxPosition === "right"
                              ? _c("th")
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasSearchablenewColumns
                      ? _c(
                          "tr",
                          [
                            _vm.showDetailRowIcon
                              ? _c("th", { class: _vm.thDetailedClasses })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.checkable && _vm.checkboxPosition === "left"
                              ? _c("th")
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.visibleColumns, function(column, index) {
                              return _c(
                                "th",
                                {
                                  key: index,
                                  class: _vm.thStickyClasses(column),
                                  style: column.style
                                },
                                [
                                  _c(
                                    "div",
                                    { class: _vm.thWrapClasses({}) },
                                    [
                                      column.searchable
                                        ? [
                                            column.$scopedSlots &&
                                            column.$scopedSlots.searchable
                                              ? [
                                                  _c("o-slot-component", {
                                                    attrs: {
                                                      component: column,
                                                      scoped: true,
                                                      name: "searchable",
                                                      tag: "span",
                                                      props: {
                                                        column: column,
                                                        filters: _vm.filters
                                                      }
                                                    }
                                                  })
                                                ]
                                              : _c("o-input", {
                                                  attrs: {
                                                    type: column.numeric
                                                      ? "number"
                                                      : "text"
                                                  },
                                                  nativeOn: _vm._d({}, [
                                                    _vm.filtersEvent,
                                                    function($event) {
                                                      return _vm.onFiltersEvent(
                                                        $event
                                                      )
                                                    }
                                                  ]),
                                                  model: {
                                                    value:
                                                      _vm.filters[column.field],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.filters,
                                                        column.field,
                                                        $$v
                                                      );
                                                    },
                                                    expression:
                                                      "filters[column.field]"
                                                  }
                                                })
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm.checkable && _vm.checkboxPosition === "right"
                              ? _c("th")
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.visibleData, function(row, index) {
                    return [
                      _c(
                        "tr",
                        {
                          key: _vm.customRowKey ? row[_vm.customRowKey] : index,
                          class: _vm.rowClasses(row, index),
                          attrs: { draggable: _vm.draggable },
                          on: {
                            click: function($event) {
                              return _vm.selectRow(row)
                            },
                            dblclick: function($event) {
                              return _vm.$emit("dblclick", row)
                            },
                            mouseenter: function($event) {
                              _vm.$listeners.mouseenter
                                ? _vm.$emit("mouseenter", row)
                                : null;
                            },
                            mouseleave: function($event) {
                              _vm.$listeners.mouseleave
                                ? _vm.$emit("mouseleave", row)
                                : null;
                            },
                            contextmenu: function($event) {
                              return _vm.$emit("contextmenu", row, $event)
                            },
                            dragstart: function($event) {
                              return _vm.handleDragStart($event, row, index)
                            },
                            dragend: function($event) {
                              return _vm.handleDragEnd($event, row, index)
                            },
                            drop: function($event) {
                              return _vm.handleDrop($event, row, index)
                            },
                            dragover: function($event) {
                              return _vm.handleDragOver($event, row, index)
                            },
                            dragleave: function($event) {
                              return _vm.handleDragLeave($event, row, index)
                            }
                          }
                        },
                        [
                          _vm.showDetailRowIcon
                            ? _c("td", { class: _vm.detailedChevronClasses }, [
                                _vm.hasDetailedVisible(row)
                                  ? _c(
                                      "a",
                                      {
                                        attrs: { role: "detailed" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation();
                                            return _vm.toggleDetails(row)
                                          }
                                        }
                                      },
                                      [
                                        _c("o-icon", {
                                          class: _vm.detailedIconExpandedClasses(
                                            row
                                          ),
                                          attrs: {
                                            icon: "chevron-right",
                                            pack: _vm.iconPack,
                                            clickable: "",
                                            both: ""
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.checkable && _vm.checkboxPosition === "left"
                            ? _c(
                                "td",
                                { class: _vm.tdCheckboxCellClasses },
                                [
                                  _c("o-checkbox", {
                                    attrs: {
                                      disabled: !_vm.isRowCheckable(row),
                                      value: _vm.isRowChecked(row)
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        $event.preventDefault();
                                        $event.stopPropagation();
                                        return _vm.checkRow(row, index, $event)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.visibleColumns, function(column, index) {
                            return [
                              column.$scopedSlots && column.$scopedSlots.default
                                ? [
                                    _c("o-slot-component", {
                                      key:
                                        (column.customKey || column.label) +
                                        index,
                                      class: _vm.columnClasses(column),
                                      attrs: {
                                        component: column,
                                        scoped: "",
                                        name: "default",
                                        tag: "td",
                                        "data-label": column.label,
                                        props: {
                                          row: row,
                                          column: column,
                                          index: index
                                        }
                                      }
                                    })
                                  ]
                                : _vm._e()
                            ]
                          }),
                          _vm._v(" "),
                          _vm.checkable && _vm.checkboxPosition === "right"
                            ? _c(
                                "td",
                                { class: _vm.tdCheckboxCellClasses },
                                [
                                  _c("o-checkbox", {
                                    attrs: {
                                      disabled: !_vm.isRowCheckable(row),
                                      value: _vm.isRowChecked(row)
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        $event.preventDefault();
                                        $event.stopPropagation();
                                        return _vm.checkRow(row, index, $event)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.isActiveDetailRow(row)
                        ? _c(
                            "tr",
                            {
                              key:
                                (_vm.customRowKey
                                  ? row[_vm.customRowKey]
                                  : index) + "detail",
                              class: _vm.detailedClasses
                            },
                            [
                              _c(
                                "td",
                                { attrs: { colspan: _vm.columnCount } },
                                [
                                  _vm._t("detail", null, {
                                    row: row,
                                    index: index
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isActiveCustomDetailRow(row)
                        ? _vm._t("detail", null, { row: row, index: index })
                        : _vm._e()
                    ]
                  }),
                  _vm._v(" "),
                  !_vm.visibleData.length
                    ? _c("tr", { class: _vm.emptyClasses }, [
                        _c(
                          "td",
                          { attrs: { colspan: _vm.columnCount } },
                          [_vm._t("empty")],
                          2
                        )
                      ])
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm.$slots.footer !== undefined
                ? _c("tfoot", [
                    _c(
                      "tr",
                      { class: _vm.footerClasses },
                      [
                        _vm.hasCustomFooterSlot()
                          ? _vm._t("footer")
                          : _c(
                              "th",
                              { attrs: { colspan: _vm.columnCount } },
                              [_vm._t("footer")],
                              2
                            )
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.loading
        ? [
            _vm._t("loading", [
              _c("o-loading", {
                attrs: { "full-page": false, active: _vm.loading },
                on: {
                  "update:active": function($event) {
                    _vm.loading = $event;
                  }
                }
              })
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      (_vm.checkable && _vm.hasBottomLeftSlot()) ||
      (_vm.paginated &&
        (_vm.paginationPosition === "bottom" ||
          _vm.paginationPosition === "both"))
        ? [
            _vm._t("pagination", [
              _c(
                "o-table-pagination",
                _vm._b(
                  {
                    attrs: {
                      "per-page": _vm.perPage,
                      paginated: _vm.paginated,
                      total: _vm.newDataTotal,
                      "current-page": _vm.newCurrentPage,
                      "root-class": _vm.paginationWrapperClasses
                    },
                    on: {
                      "update:currentPage": function($event) {
                        _vm.newCurrentPage = $event;
                      },
                      "update:current-page": function($event) {
                        _vm.newCurrentPage = $event;
                      },
                      "page-change": function(event) {
                        return _vm.$emit("page-change", event)
                      }
                    }
                  },
                  "o-table-pagination",
                  _vm.$attrs,
                  false
                ),
                [_vm._t("bottom-left")],
                2
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    undefined,
    undefined,
    undefined
  );

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, __vue_component__$3);
    registerComponent(Vue, __vue_component__$1);
  }
};
use(Plugin);

export default Plugin;
export { __vue_component__$3 as OTable, __vue_component__$1 as OTableColumn };
